module.exports = __webpack_public_path__ + "static/media/cluster-terminology-3.58acbd25.jpg";